import { AppError } from './app-error';

/**
 * Custom error class representing bad input or validation errors.
 * Extends the base AppError class.
 */
export class AppBadError extends AppError {

}
